import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';

@Component({
  selector: 'app-clio-list-documents',
  templateUrl: './ClioListDocuments.component.html',
  styles: [`.documents-search {
  width: 100%;
}
.documents-list {
  max-height: 45vh;
  overflow-y: auto;
  border-bottom: 1px solid #ccc;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding-top: 0;
}
.no-results {
  padding: 12px 4px;
  color: #888;
}`]
})
export class ClioListDocumentsComponent {
  @Input() documentsList = [];
  @Input() selectedMatter: any;
  @ViewChild('matSelectionList') matSelectionList: MatSelectionList;
  @Output() imporEvent = new EventEmitter<any>();
  importButtonsEnabled = true;
  searchTerm = '';

  constructor() { }

  matchesSearch(item: any): boolean {
    const term = (this.searchTerm || '').trim().toLowerCase();
    if (!term) {
      return true;
    }
    return (item.name || '').toLowerCase().includes(term);
  }

  hasVisibleDocuments(): boolean {
    return (this.documentsList || []).some(item => this.matchesSearch(item));
  }

  importSelectedDocuments() {
    this.imporEvent.emit(this.matSelectionList.selectedOptions.selected);
  }
  importAllDocuments() {
    this.importButtonsEnabled = false;
    this.matSelectionList.selectAll();
    this.importSelectedDocuments();
  }

  handleChange(obj) {
    console.log(obj);
  }

}
